export default {
    namespaced: true,
    state: {
        content: '',
        color: '',
        multiline: false
    },
    mutations: {
        showMessage (state, payload) {
            state.content = payload.content
            state.color = payload.color
            state.multiline = payload.multiline
        }
    }
}
